import Immutable from "immutable";

const initialState = {
    email: "",
    emailErrors: [],
    password: "",
    passwordErrors: [],
    passwordConfirmation: "",
    passwordConfirmationErrors: [],
    sending: false,
    sendingFailed: false,
    sendingError: "",
    sendingCompleted: false,
    formErrorsVisible: false,
    resetting: false,
    resettingFailed: false,
    resettingError: "",
    resettingCompleted: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_PASSWORD_RECOVERY_EMAIL":
            return Immutable
                .fromJS(state)
                .set("email", action.value)
                .set("emailErrors", action.errors)
                .toJS();
        case "UPDATE_PASSWORD_RECOVERY_PASSWORD":
            return Immutable
                .fromJS(state)
                .set("password", action.value)
                .set("passwordErrors", action.errors)
                .toJS();
        case "UPDATE_PASSWORD_RECOVERY_PASSWORD_CONFIRMATION":
            return Immutable
                .fromJS(state)
                .set("passwordConfirmation", action.value)
                .set("passwordConfirmationErrors", action.errors)
                .toJS();
        case "INIT_PASSWORD_RECOVERY_FORM":
            return Immutable
                .fromJS(state)
                .set("email", action.email)
                .set("emailErrors", action.emailErrors)
                .set("password", action.password)
                .set("passwordErrors", action.passwordErrors)
                .set("passwordConfirmation", action.passwordConfirmation)
                .set("passwordConfirmationErrors", action.passwordConfirmationErrors)
                .set("formErrorsVisible", false)
                .toJS();
        case "DISPLAY_PASSWORD_RECOVERY_VALIDATION_ERRORS":
            return Immutable
                .fromJS(state)
                .set("formErrorsVisible", true)
                .toJS();
        case "REQUEST_PASSWORD_RECOVERY_PENDING":
            return Immutable
                .fromJS(state)
                .set("sending", true)
                .set("sendingFailed", false)
                .set("sendingError", "")
                .toJS();
        case "REQUEST_PASSWORD_RECOVERY_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("sending", false)
                .set("sendingCompleted", true)
                .toJS();
        case "REQUEST_PASSWORD_RECOVERY_REJECTED":
            return Immutable
                .fromJS(state)
                .set("sending", false)
                .set("sendingFailed", true)
                .set("sendingError", action.payload.response.data.message)
                .toJS();
        case "COMPLETE_PASSWORD_RECOVERY_PENDING":
            return Immutable
                .fromJS(state)
                .set("resetting", true)
                .set("resettingFailed", false)
                .set("resettingError", "")
                .toJS();
        case "COMPLETE_PASSWORD_RECOVERY_FULFILLED":
            return Immutable
                .fromJS(state)
                .set("resetting", false)
                .set("resettingCompleted", true)
                .toJS();
        case "COMPLETE_PASSWORD_RECOVERY_REJECTED":
            return Immutable
                .fromJS(state)
                .set("resetting", false)
                .set("resettingFailed", true)
                .set("resettingError", action.payload.response.data.message)
                .toJS();
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/passwordRecovery.js